import {
  ICartResponseView,
  ProductsEntity,
  TheProduct,
} from "../../modules/cart/models/ICartResponseView";
import { IProductResponseView } from "../../modules/products/models/IProductResponseView";
import { ToastUtil } from "../../utils/ToastUtil";

export class CartReduxService {
  private static PRODUCT_TAX: number = 5.0;

  public static convertToProductEntity(
    product: IProductResponseView
  ): TheProduct {
    return {
      _id: product._id,
      count: product.count,
      price: product.price,
      imageUrl: product.imageUrl,
      quantity: product.quantity,
      brand: product.brand,
      sold: product.sold,
      categoryObj: product.categoryObj._id,
      subCategoryObj: product.subCategoryObj._id,
      title: product.title,
      description: product.description,
      userObj: product.userObj._id,
    };
  }

  public static addToCartUtil(
    cart: ICartResponseView,
    product: TheProduct,
    count: number
  ): ICartResponseView {
    const existingProduct = cart.products.find(
      (item) => item.product._id === product._id
    );

    if (existingProduct) {
      ToastUtil.displayErrorToast("Item Already Exists");
      return cart;
    } else {
      ToastUtil.displaySuccessToast("Item Added To Cart");
      return {
        ...cart,
        products: [
          ...cart.products,
          { product: { ...product }, count: count, price: product.price },
        ],
      };
    }
  }

  public static incrementProductQtyUtil(
    cart: ICartResponseView,
    productId: string
  ): ICartResponseView {
    return {
      ...cart,
      products: cart.products.map((product) => {
        if (product._id === productId) {
          return {
            ...product,
            count: product.count + 1,
          };
        }
        return product;
      }),
    };
  }

  public static decrementProductQtyUtil(
    cart: ICartResponseView,
    productId: string
  ): ICartResponseView {
    return {
      ...cart,
      products: cart.products.map((product) => {
        if (product.product._id === productId) {
          const newCount = product.count - 1;
          return {
            ...product,
            count: newCount > 0 ? newCount : 1, // Ensure count doesn't go below 1
          };
        }
        return product;
      }),
    };
  }

  public static deleteProductItemUtil(
    cart: ICartResponseView,
    productId: string
  ): ICartResponseView {
    ToastUtil.displayInfoToast("Item Removed From the Cart!");
    return {
      ...cart,
      products: cart.products.filter((product) => product._id !== productId),
    };
  }

  public static calculateTotalUtil(products: TheProduct[]): number {
    let total: number = 0;
    for (let product of products) {
      total += Number(product.price) * Number(product.count);
    }
    return total;
  }

  public static calculateTaxUtil(products: TheProduct[]): number {
    const total = this.calculateTotalUtil(products);
    return (total * this.PRODUCT_TAX) / 100;
  }

  public static calculateGrandTotal(products: TheProduct[]): number {
    const grandTotal =
      this.calculateTotalUtil(products) + this.calculateTaxUtil(products);
    return grandTotal;
  }

  public static convertToProductNewResponseView = (
    products: ProductsEntity[]
  ): TheProduct[] => {
    return products.map((item: ProductsEntity) => {
      return {
        _id: item.product._id,
        title: item.product.title,
        description: item.product.description,
        imageUrl: item.product.imageUrl,
        brand: item.product.brand,
        price: item.product.price,
        quantity: item.product.quantity,
        sold: item.product.sold,
        userObj: item.product.userObj,
        categoryObj: item.product.categoryObj,
        subCategoryObj: item.product.subCategoryObj,
        createdAt: item.product.createdAt,
        updatedAt: item.product.updatedAt,
        count: item.count,
      };
    });
  };

  public static convertToProductsEntity = (products: TheProduct[]): ProductsEntity[] => {
    return products.map(product => ({
      product,
      count: product.count,
      price: product.price,
      _id: product._id,
    }));
  };
  
  public static convertToTheProduct = (products: ProductsEntity[]): TheProduct[] => {
    return products.map(entity => ({
      ...entity.product,
      count: entity.count,
    }));
  };
  
}
